import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from '../loader.service';
import { SKIP_GLOBAL_LOADER } from './loader-context';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(public loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const excludedRequest =
      req.url.includes('/rest/search/tag-names') ||
      req.url.includes('/rest/profiles/candidates') ||
      req.url.includes('/rest/reviews/v2/responses') ||
      req.url.includes('/rest/reviews/v1/responses') ||
      req.url.includes('/rest/reviews/V1/myContribution') ||
      req.url.includes('/rest/profiles/virtualEvent') ||
      req.url.includes('/rest/profiles/announcements');
    const locallyHandledRequest =
      this.loaderService.disable || req.context.get(SKIP_GLOBAL_LOADER);

    // `disable` is a one-request opt-out used by components that render their
    // own progress UI. Consume it here so it cannot suppress a later request.
    this.loaderService.disable = false;
    const shouldShowGlobalLoader =
      !excludedRequest &&
      !locallyHandledRequest &&
      !this.loaderService.isGlobalLoaderSuppressed;

    if (shouldShowGlobalLoader) {
      this.loaderService.beginRequest();
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (shouldShowGlobalLoader) {
          this.loaderService.endRequest();
        }
      })
    );
  }
}
